export const AnswerBlock = ({ children, dark = false }) => (
  <div
    data-testid="answer-block"
    className={`border-l-4 border-clinic p-6 md:p-8 ${
      dark ? "bg-white/5" : "bg-clinic-tint"
    }`}
  >
    <p
      className={`font-mono text-[11px] tracking-[0.25em] uppercase mb-3 ${
        dark ? "text-clinic-light" : "text-clinic"
      }`}
    >
      Risposta in breve
    </p>
    <p className={`text-base md:text-lg leading-relaxed ${dark ? "text-paper/90" : "text-ink"}`}>
      {children}
    </p>
  </div>
);
